import { render } from "./DemandStatusLabel.component.vue?vue&type=template&id=ccc6131c&scoped=true"
import script from "./DemandStatusLabel.component.vue?vue&type=script&lang=js"
export * from "./DemandStatusLabel.component.vue?vue&type=script&lang=js"

import "./DemandStatusLabel.component.vue?vue&type=style&index=0&id=ccc6131c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc6131c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
